// Hideo - the pure logic of drag-to-reorder lists (Settings › Tags, the "Manage tags" dialog, Settings › Plan
// checklist items). The pointer handling is src/composables/useDragSort.ts. A "gap" is a place between two rows: gap 0
// is before the first row, gap n after the last one.

/** The gap the pointer is in: the number of rows whose middle is above it (mids = vertical middle of every row) */
export const gapAt = (mids: readonly number[], y: number): number => mids.filter(m => m < y).length

/** The index the dragged row takes when dropped in a gap; null when the gap is right before or after it (no move) */
export function targetIndex(from: number, gap: number, n: number): number | null {
  if (from < 0 || from >= n || gap < 0 || gap > n || gap === from || gap === from + 1) return null
  return gap > from ? gap - 1 : gap
}

/** Moves the item at `from` to index `to`, in place. False when nothing changed (same place or an index out of range). */
export function moveItem<T>(list: T[], from: number, to: number): boolean {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return false
  const [x] = list.splice(from, 1)
  list.splice(to, 0, x)
  return true
}
